import { useCompanyId } from '@startuptools/common/react-wrapper';
import { SipShareSubscriptionNote } from './SipShareSubscriptionNote';
import { useSipShareSubscriptionNoteListSuspenseQuery } from './SipShareSubscriptionNoteList.graphql';
import { Stack } from '@startuptools/ui/Stack';

export const SipShareSubscriptionNoteList = ({ shareIssueId }: { shareIssueId: string }) => {
  const companyId = useCompanyId();
  const {
    data: { shareIssue, shareIssueRegistrations, company },
  } = useSipShareSubscriptionNoteListSuspenseQuery({
    variables: { companyId, shareIssueId },
    fetchPolicy: 'cache-and-network',
  });

  const participants = shareIssueRegistrations.flatMap(sir => sir.participants);

  return (
    <Stack gap={1}>
      {participants.map(sip => (
        <SipShareSubscriptionNote key={sip.id} sip={sip} shareIssue={shareIssue} company={company} />
      ))}
    </Stack>
  );
};
